/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { createFlagEnum } from 'fierry/util/enum';


export default createFlagEnum('Zone', 'Dock', 'Galaxy', 'Platform')
